import React from "react"

export default function About() {
    return (
        <div className="contactPage">
        <div className="contactPageDiv" id="contactPageDivId">
        <div className="aboutPageColumn">
            <div className="aboutPageInfoParagraph1">
            Assa is an app for learning Chinese language with associations. 
            Every Chinese character consists of small parts that are called radicals. 
            The radicals are mostly not divided into parts. 
            Each of them has its own meaning. 
            And the characters combine the radicals not just randomly, usually Chinese people were putting meaning into combining them. 
            Chinese characters are unique, the modern characters are simplified versions of the traditional characters, but they still consist of parts of the radicals that traditional characters consisted of.
            </div>
            <div className="aboutPageInfoParagraph2">
            In our app we create our own associations for the characters to better memorize them based on the radicals that they consist of.
            We hope this way will help you to remember characters in associations way but not as some random pictures which exist in infinite amount because there are around 80 000 characters in Chinese language.
            You will notice the connection of characters based on their meaning in a while, that can help you even analyze the connection that Chinese people were putting into it. 
            So, you don't know how to remember characters? Then try out Assa
            </div>
            </div>
        
        </div>
    </div>
    )
}